export const inputClass = `w-full border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:border-blue-700 focus:ring-1 focus:ring-blue-700 p-2`;
export const messageError = `text-red-500 block`;
